import { Text, Main, THEME_COLORS } from '../../utils/theme';
import styled from 'styled-components';

export const TimeContainer = styled(Main)`
  position: absolute;
  display: flex;
  justify-content: left;
  top: 0vw;
  left: 0vw;
  width: 20vw;
  margin: 1vw 0vw;

  @media (max-width: 600px) {
    position: absolute;
    display: flex;
    justify-content: left;
    top: 0vw;
    left: 0vw;
    width: 50vw;
  }
`;

export const TimeNumber = styled.div`
  color: ${THEME_COLORS.brandPink};
  display: flex;
  justify-content: space-between;
  font-size: 2vw;
  font-weight: bold;

  @media (max-width: 600px) {
    font-size: 7vw;
  }
`;

export const TimeText = styled(Text)`
  margin: 0px;
  font-size: 1vw;
  text-align: left;

  @media (max-width: 600px) {
    font-size: 3vw;
    text-align: center;
  }
`

export const TimeSubText = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 1.25vw;

  @media (max-width: 600px) {
    font-size: 4vw;
  }
`;

export const TimeItem = styled.div`
  width: 4vw;
  text-align: center;
  display: flex;
  justify-content: center;

  @media (max-width: 600px) {
    width: 10vw;
  }
`

export const ApplyButtonContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: left;
  top: 8vw;
  left: 0vw;

  @media (max-width: 600px) {
    position: absolute;
    display: flex;
    justify-content: center;
    top: 22vw;
    left: 0vw;
    width: 50vw;
  }
`;

export const ApplyButtonItem = styled.img`
  z-index: 3;
  width: 10vw;
  cursor: pointer;
  margin: 5px;
  
  @media (max-width: 600px) {
    width: 35vw;
  }
`;
